import { Box, Card } from '@mui/material'
import React, { FC } from 'react'
import { Component } from '../../types/ContentStructure'
import ComponentType from './ComponentType'
import AutoPlaySwipeableViews from '../AutoPlaySwipeableViews '
import ComponentCarrusel from './ComponentCarrusel'
import ComponentBannerProducto from './ComponentBannerProducto'

interface IComponentSectionProps {
    component: Component
    sx?: any
}
const ComponentSection: FC<IComponentSectionProps> = ({ component, sx = {} }) => {

    const { components } = component;
    const [activeStep, setActiveStep] = React.useState(0);
    const handleStepChange = (step: number) => {
        setActiveStep(step);
    };
    return (
        <Box sx={[
            {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'stretch',
                width: '100%',
                //minHeight: { sx: '764px', sm: '1024px', md: '768px', lg: '768px' }
            }, sx
        ]}>
            {/* Mostrar si es banner texto o banner texto y logo */}
            {components.find(
                (item: Component) =>
                    item.componentType.name === 'BANNER TEXTO'
                    || item.componentType.name === 'BANNER TEXTO Y LOGO'
            ) &&
                <Box sx={{ width: '100%' }}>
                    {components.map((item: Component, idx: number) => {
                        return <ComponentType key={idx} component={item} />
                    })}
                </Box>
            }
            {/* Mostrar si es BANNER, CARRUSEL o BANNER PRODUCTO */}
            {components.find(
                (item: Component) =>
                    item.componentType.name === 'BANNER'
                    || item.componentType.name === 'CARRUSEL'
                    || item.componentType.name === 'BANNER PRODUCTO'
            ) &&
                <Box sx={{ width: '100%', overflow: 'hidden' }}>
                    {/* BANNER PRODUCTO: hero directo — solo items de tipo BANNER PRODUCTO */}
                    {components.find((item: Component) => item.componentType.name === 'BANNER PRODUCTO') && (() => {
                        const bannerItems = components.filter((item: Component) => item.componentType.name === 'BANNER PRODUCTO')
                        return (
                            <>
                                {/* Desktop/Tablet */}
                                <Box sx={{ display: { xs: 'none', sm: 'block' }, width: '100%' }}>
                                    {bannerItems.map((item: Component, idx: number) => (
                                        <ComponentType key={idx} component={item} />
                                    ))}
                                </Box>
                                {/* Mobile: tarjeta mini compacta */}
                                <Box sx={{ display: { xs: 'block', sm: 'none' }, width: '100%' }}>
                                    {bannerItems.map((item: Component, idx: number) => (
                                        <ComponentBannerProducto key={idx} component={item} mini={true} />
                                    ))}
                                </Box>
                            </>
                        )
                    })()}
                    {/* CARRUSEL: solo items de tipo CARRUSEL — no mezclar con BANNER PRODUCTO */}
                    {!components.find((item: Component) => item.componentType.name === 'BANNER PRODUCTO') &&
                        components.find((item: Component) => item.componentType.name === 'CARRUSEL') && (() => {
                            const carruselItems = components.filter((item: Component) => item.componentType.name === 'CARRUSEL')
                            return (
                                <>
                                    {/* Desktop/Tablet: slider autoplay */}
                                    <Box sx={{ display: { xs: 'none', sm: 'none', md: 'block' }, width: '100%' }}>
                                        <AutoPlaySwipeableViews index={activeStep} onChangeIndex={handleStepChange} enableMouseEvents interval={5000}>
                                            {carruselItems.map((item: Component, idx: number) => (
                                                <ComponentType key={idx} component={item} />
                                            ))}
                                        </AutoPlaySwipeableViews>
                                    </Box>
                                    {/* Mobile: grid 2 cols */}
                                    <Box sx={{ display: { xs: 'grid', sm: 'grid', md: 'none' }, gridTemplateColumns: 'repeat(2, 1fr)', width: '100%' }}>
                                        {carruselItems.map((item: Component, idx: number) => (
                                            <ComponentCarrusel key={idx} component={item} mini={true} />
                                        ))}
                                    </Box>
                                </>
                            )
                        })()}
                    {/* BANNER (hero slides): siempre en slider autoplay */}
                    {components.find((item: Component) => item.componentType.name === 'BANNER') && (
                        <AutoPlaySwipeableViews index={activeStep} onChangeIndex={handleStepChange} enableMouseEvents interval={5000}>
                            {components.map((item: Component, idx: number) => (
                                <ComponentType key={idx} component={item} />
                            ))}
                        </AutoPlaySwipeableViews>
                    )}
                </Box>
            }
            {/* Mostrar si es banner o carrusel */}
            {components.find(
                (item: Component) =>
                    item.componentType.name === 'NOTICIA EXTERNA'
            ) &&
                <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: {
                        xs: '1fr',
                        sm: '1fr',
                        md: 'repeat(2, 1fr)',
                        lg: 'repeat(3 ,1fr)',
                    },
                    gap: 2,
                    pb: 2,
                }}>
                    <Card sx={[
                        {
                            borderRadius: 15,
                            display: 'flex',
                            flexDirection: 'column',
                            backgroundColor: '#00041E',
                            backgroundImage: 'url(https://content.mecap.mx/CMSMecap/Avantthya/Content/Image/IMG-SECCION_NOTICIAS_EXTERNAS_1f5564c6a-758a-404a-b32b-988186d743aa.png)',
                            backgroundSize: 'contain',
                            backgroundPosition: 'top left',
                            backgroundRepeat: 'no-repeat',
                            textAlign: 'left',
                            textWrap: 'pretty',
                            aspectRatio: { xs: '1/1', md: '1/1' },
                            height: { xs: '80vw', sm: '60vw', md: '35vh', lg: '40vh' }
                        }
                    ]}
                    >

                    </Card>
                    {components.map((item: Component, idx: number) => {
                        return <ComponentType key={idx} component={item} />
                    })}
                </Box>
            }
            {
                components.find(
                    (item: Component) =>
                        item.componentType.name !== 'BANNER TEXTO'
                        && item.componentType.name !== 'BANNER TEXTO Y LOGO'
                        && item.componentType.name !== 'BANNER'
                        && item.componentType.name !== 'CARRUSEL'
                        && item.componentType.name !== 'BANNER PRODUCTO'
                        && item.componentType.name !== 'NOTICIA EXTERNA'
                ) &&
                <Box sx={{ width: '100%' }}>
                    {components.map((item: Component, idx: number) => {
                        return (
                            <>
                                { }
                                <ComponentType key={idx} component={item} />
                            </>
                        )
                    })}
                </Box>
            }
        </Box>
    )
}

export default ComponentSection
